import { Col, Row } from "react-bootstrap";
import Button from "@mui/material/Button";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import React from "react";
import { useTranslation } from "react-i18next";

interface DomainMappingHeaderToolbarProps {
  onAddDomainClick?: () => void;
  isEdit: boolean;
}

export function DomainMappingHeaderToolbar(props: DomainMappingHeaderToolbarProps) {
  const { t } = useTranslation();

  return (
    <Row>
      <Col>
        {props.isEdit && (
          <Button
            variant="contained"
            color="primary"
            onClick={props.onAddDomainClick}
            startIcon={<FontAwesomeIcon style={{ cursor: "pointer" }} icon={faPlus} />}
          >
            {t("settings.addDomain")}
          </Button>
        )}
      </Col>
    </Row>
  );
}
